import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import Manhole from 'features/processFlowDiagrams/svg/apparatus-elements/manhole.svg?react'
import SocketConnectionNozzle from 'features/processFlowDiagrams/svg/apparatus-elements/socket-connection-nozzle.svg?react'
import SupportBracket from 'features/processFlowDiagrams/svg/apparatus-elements/support-bracket.svg?react'
import SupportLeg from 'features/processFlowDiagrams/svg/apparatus-elements/support-leg.svg?react'
import SupportRing from 'features/processFlowDiagrams/svg/apparatus-elements/support-ring.svg?react'
import SupportSkirt from 'features/processFlowDiagrams/svg/apparatus-elements/support-skirt.svg?react'
import React from 'react'

export const PID_APPARATUS_ELEMENTS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'manhole',
    name: 'Manhole',
    category: 'apparatus-elements',
    svgContent: <Manhole />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'socket-connection-nozzle',
    name: 'Socket, Connection Nozzle',
    category: 'apparatus-elements',
    svgContent: <SocketConnectionNozzle />,
    viewBox: '0 0 30 40',
  },
  {
    id: 'support-bracket',
    name: 'Support Bracket',
    category: 'apparatus-elements',
    svgContent: <SupportBracket />,
    viewBox: '0 0 10 10',
  },
  {
    id: 'support-leg',
    name: 'Support Leg',
    category: 'apparatus-elements',
    svgContent: <SupportLeg />,
    viewBox: '0 0 25 100',
  },
  {
    id: 'support-ring',
    name: 'Support Ring',
    category: 'apparatus-elements',
    svgContent: <SupportRing />,
    viewBox: '0 0 100 25',
  },
  {
    id: 'support-skirt',
    name: 'Support Skirt',
    category: 'apparatus-elements',
    svgContent: <SupportSkirt />,
    viewBox: '0 0 100 100',
  },
]
